<template>
  <div class="flex flex-col gap-4">
    <div class="flex items-center justify-center">
      <GImage name="usdt-usdc" size="4xl" />
    </div>

    <p class="text-3 font-medium text-secondary-txt">
      Recibe y envía USDT y USDC de forma rápida, con transferencias en minutos y costos transparentes.
    </p>

    <div class="flex gap-[10px] items-start">
      <div class="flex items-center justify-center min-w-[32px] min-h-[32px] p-1 bg-everBlue-25 rounded shrink-0">
        <GIconFont name="regular info-circle" class="text-primary-def text-sm" />
      </div>
      <div class="flex flex-col gap-1 pt-1 flex-1 min-w-0">
        <p class="text-3 font-bold text-secondary-txt">Direcciones únicas</p>
        <p class="text-3 font-medium text-terciary-txt">
          Generamos direcciones exclusivas para recibir USDT y USDC.
        </p>
      </div>
    </div>

    <div class="flex gap-[10px] items-start">
      <div class="flex items-center justify-center min-w-[32px] min-h-[32px] p-1 bg-everBlue-25 rounded shrink-0">
        <GIconFont name="regular dollar-sign" class="text-primary-def text-sm" />
      </div>
      <div class="flex flex-col gap-1 pt-1 flex-1 min-w-0">
        <p class="text-3 font-bold text-secondary-txt">Envíos rápidos</p>
        <p class="text-3 font-medium text-terciary-txt">
          Transferencias procesadas en hasta 5 minutos.
        </p>
      </div>
    </div>

  </div>
</template>

<script lang="ts" setup>
import { GIconFont } from '@flash-global66/g-icon-font';
import { GImage } from '@flash-global66/g-image';
</script>
